import React from "react";
import "./Dots.css";
function Dots() {
  return (
    <div className="dots">
      <div className="red"></div>
      <div className="yellow"></div>
      <div className="green"></div>
    </div>
  );
}

export default Dots;
